import _ from 'lodash';
import numeral from 'numeral';
import React from 'react';
import PropTypes from 'prop-types';

import BackstageApi    from 'app/apis/backstage';
import AddressInput    from 'app/components/common/address-input';
import Checkbox        from 'app/components/common/checkbox';
import Icon            from 'app/components/common/icon';
import Link            from 'app/components/common/link';
import Modal           from 'app/components/common/modal';
import NteePicker      from 'app/components/common/ntee-picker';
import StandardInput   from 'app/components/common/standard-input';
import StandardSelect  from 'app/components/common/standard-select';
import {
  Categories,
}                      from 'app/constants';
import history         from 'app/history';
import paths           from 'app/paths';
import countries         from 'app/helpers/countries';

const countryOpts = countries.sorted.map(c => {
  return {label: `${c.flag} ${c.name}`, value: c.code3};
}).filter(o => o.value !== 'USA');

class ModalNewPvs extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      createPending: false,
      success: false,
      failed: false,

      name: null,
      website: null,
      country: null,
      registryName: null,
      registeredNumber: null,
      locale: null,
    };


    this.onSelectCountry = this.onSelectCountry.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeWebsite = this.onChangeWebsite.bind(this);
    this.onChangeRegistryName = this.onChangeRegistryName.bind(this);
    this.onChangeRegisteredNumber = this.onChangeRegisteredNumber.bind(this);
    this.onChangeLocale = this.onChangeLocale.bind(this);

    this.onClickCreate = this.onClickCreate.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      createPending: false,
      success: false,
      failed: false,
    });
  }

  get saveParams() {
    return {
      nonprofitName: (this.state.name || '').trim(),
      website: (this.state.website || '').trim(),
      registryName: (this.state.registryName || '').trim(),
      registryId: (this.state.registeredNumber || '').trim(),
      locale: (this.state.locale || '').trim(),
      ccIso3: this.state.country || null,
    };
  }

  get canSubmit() {
    if (this.state.createPending) return false;
    const params = this.saveParams;
    if (!params.nonprofitName) return false;
    if (!params.website) return false;
    if (!params.ccIso3) return false;
    if (!params.registryName) return false;
    if (!params.registryId) return false;
    if (!params.locale) return false;
    return true;
  }

  onChangeName(event) {
    const name = event.target.value;
    this.setState({name});
  }
  onChangeWebsite(event) {
    const website = event.target.value;
    this.setState({website});
  }
  onChangeRegistryName(event) {
    const registryName = event.target.value;
    this.setState({registryName});
  }
  onChangeRegisteredNumber(event) {
    const registeredNumber = event.target.value;
    this.setState({registeredNumber});
  }
  onChangeLocale(event) {
    const locale = event.target.value;
    this.setState({locale});
  }
  onSelectCountry(country) {
    this.setState({country});
  }

  onCloseModal() {
    this.props.onClose();
  }

  onClickCreate() {
    this.setState({createPending: true});
    BackstageApi.pvssCreateIntl(this.saveParams)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        alert('Oops! Request failed. Error has been logged to developer console - check there.');
        console.error(error);
        this.setState({failed: true, createPending: false});
      });
  }

  render() {
    const {irsEntity} = this.props;
    const {
      name, website, locale, country, registryName, registeredNumber,
      createPending,
    } = this.state;
    return (
      <Modal className="bform bs-modal-edit-np" onClose={this.onCloseModal}>
        <h1 className="bform-h1">New Percent Validation Submission</h1>
        <p><i>Only</i> use this to send a request to Percent to validate a new international nonprofit that's not yet in their database.</p>
        <p>For US orgs, intitiate this process from the page for the org.</p>
        <p>For international orgs already in Percent's DB, use the global org search page.</p>

        <label className="bform-h3">Name</label>
        <StandardInput name="name" label="Space Cat Rescue" value={name || ''} onChange={this.onChangeName} />

        <label className="bform-h3">Website</label>
        <p className="bform-input-desc faint">Can't be blank. Use example.com if one doesn't exist.</p>
        <StandardInput name="website" value={website || ''} onChange={this.onChangeWebsite} label="https://spacecats.org" />

        <label className="bform-h3">Country</label>
        <StandardSelect options={countryOpts} onSelect={this.onSelectCountry} value={country} />

        <label className="bform-h3">Locale</label>
        <p className="bform-input-desc faint">Use a valid RFC 5646 code. Some examples: en-US, en-GB, es-MX, es-ES</p>
        <StandardInput name="locale" value={locale || ''} onChange={this.onChangeLocale} label="es-MX" />

        <label className="bform-h3">Registry ID</label>
        <p className="bform-input-desc faint">Official ID given by the registry. (equivalent to EIN for US orgs)</p>
        <StandardInput name="registeredNumber" value={registeredNumber || ''} onChange={this.onChangeRegisteredNumber} label="abc-123" />

        <label className="bform-h3">Name of Registry</label>
        <p className="bform-input-desc faint">Name of the official registry. (equivalent to "Internal Revenue Service" for US orgs)</p>
        <StandardInput name="registryName" value={registryName || ''} onChange={this.onChangeRegistryName} label="Martian Charity Registry" />

        <div className="bform-actions">
          <div />
          <button className="btn blue" onClick={this.onClickCreate} disabled={!this.canSubmit}>{createPending ? 'Sending...' : 'Send Request'}</button>
        </div>
      </Modal>
    );
  }

}

ModalNewPvs.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ModalNewPvs;

